import { getAuthProvider } from '../auth/providers';

/**
 * Get the session token for API calls.
 * Per react-oidc-context docs:
 * https://github.com/authts/react-oidc-context#call-a-protected-api
 */
export const getSessionToken = (): string | null => {
  return getAuthProvider().getSessionToken();
};
